### Helper ###
Element.prototype.hasClass = (className) ->
  classArray = this.className.split(' ')
  return classArray.indexOf(className) >= 0

Element.prototype.addClass = (className) ->
  if(!this.hasClass(className))
    classArray = this.className.split(' ')
    classArray.push(className)
    this.className = classArray.join(' ')
  return this

Element.prototype.removeClass = (className) ->
  classArray = this.className.split(' ')
  index = classArray.indexOf(className)
  if(index >= 0)
    classArray.splice(index, 1)
    this.className = classArray.join(' ')
  return this

Element.prototype.toggleClass = (className) ->
  if this.hasClass(className) then this.removeClass(className) else this.addClass(className)

isMobile = ->
  ua = navigator.userAgent;
  if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0) && (ua.indexOf('Mobile') > 0) || ua.indexOf('Windows Phone') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0)
    return true
  return false

getPageOffset = ->
  return if window.pageYOffset isnt undefined then window.pageYOffset else document.documentElement.scrollTop

### Main ###

# Init SmoothScroll
headerHeight = document.getElementById('header').clientHeight
smoothScroll.init({ offset: headerHeight })

# Properties
mainNavAnchors = document.getElementById('mainNav').getElementsByTagName('a')
spNav = document.getElementById('spNav')
videoModal = document.getElementById('videoModal')
targetOffsets = []
lang = document.getElementsByTagName('html')[0].lang
langNavAnchors = document.getElementById('langNav').getElementsByTagName('a')
spLangNavAnchors = document.getElementById('spLangNav').getElementsByTagName('a')
lastImage = document.getElementById('lastImage')
contactUs = document.getElementById('contactUs')
video = document.getElementById('video')
videoThumbnail = document.getElementById('thumbnail')
youtube = document.getElementById('youtube')
spMenuButton = document.getElementById('spMenuButton')
modalInner = document.getElementById('modalInner')
closeButton = document.getElementById('closeButton')

# Methods
getTargetOffsets = ->
  targetOffsets = [0]
  allArticles = document.getElementsByClassName('scroll-target')
  for article in allArticles
    top = article.getBoundingClientRect().top + window.pageYOffset - headerHeight - 1
    targetOffsets.push(top)
  targetOffsets.push(document.body.clientHeight)

setVideoVisibility = ->
  if isMobile()
    video.className = "hidden"
    videoThumbnail.className = "video-thumbnail"

updateActiveAnchor = ->
  if targetOffsets.length is 0 then return
  pageOffset = getPageOffset()
  for i in [2...targetOffsets.length]
    if targetOffsets[i - 1] <= pageOffset && pageOffset < targetOffsets[i]
      mainNavAnchors[i - 2].className = "active"
    else
      mainNavAnchors[i - 2].className = ""

switchLangNav = ->
  if lang == 'en'
    langNavAnchors[0].addClass('active')
    spLangNavAnchors[0].addClass('active')
  else
    langNavAnchors[1].addClass('active')
    spLangNavAnchors[1].addClass('active')

adjustContactUsMarginTop = ->
  lastImageHeight = lastImage.clientHeight
  if lastImageHeight != 0
    # xs or sm
    ADJUSTMENT_HEIGHT = 100
    return contactUs.style.marginTop = lastImageHeight - ADJUSTMENT_HEIGHT + 'px'
  # md or lg
  return contactUs.style.marginTop = '0px'
  
shakeWatchVideoAnchor = ->
  watchVideoAnchor = document.getElementById('watchVideoAnchor')
  if watchVideoAnchor != undefined
    watchVideoAnchor.addClass('animated tada')

updateVideoModalSize = ->
  screenWidth = window.innerWidth
  screenHeight = window.innerHeight
  if screenWidth < screenHeight
    screenHeight = screenWidth
  buttonHeight = closeButton.clientHeight
  YOUTUBE_MARGIN_BOTTOM = 24
  PADDING_BOTTOM = 32
  youtubeMaxHeight = screenHeight - buttonHeight - YOUTUBE_MARGIN_BOTTOM - PADDING_BOTTOM
  youtubeMaxWidth = (16 * youtubeMaxHeight) / 9
  modalInner.style.maxWidth = if isMobile() || youtubeMaxWidth < youtube.clientWidth then youtubeMaxWidth + 'px' else ''

window.toggleSpNav = (isClose) ->
  if (isClose)
    spNav.removeClass('open')
    spMenuButton.removeClass('active')
    return
  spNav.toggleClass('open')
  spMenuButton.toggleClass('active')

window.toggleVideoModal = (isClose) ->
  open = ->
    video.pause()
    document.body.style.top = -1 * getPageOffset() + 'px'
    document.body.style.position = 'fixed'
    document.body.style.width = '100%'
    youtube.innerHTML = '<iframe width="853" height="480" src="https://www.youtube.com/embed/QyLYDImSMTo?rel=0&autoplay=1" frameborder="0" allowfullscreen></iframe>'
    videoModal.addClass('open')
    updateVideoModalSize()
  close = ->
    youtube.innerHTML = ''
    videoModal.removeClass('open')
    if !isMobile() then video.play()
    document.body.style.position = ''
    document.body.style.width = ''
    pageOffsetY = -1 * parseInt(document.body.style.top)
    document.body.style.top = ''
    scrollTo(0, pageOffsetY)
  if isClose || videoModal.hasClass('open')
    close()
  else
    open()


# Scroll Event
window.onscroll = ->
  updateActiveAnchor()

# Resize Event
window.onresize = ->
  getTargetOffsets()
  updateActiveAnchor()
  adjustContactUsMarginTop()
  updateVideoModalSize()

window.onorientationchange = ->
  getTargetOffsets()
  updateActiveAnchor()
  adjustContactUsMarginTop()
  updateVideoModalSize()

# Initialize
window.onload = ->
  getTargetOffsets()
  setVideoVisibility()
  switchLangNav()
  updateActiveAnchor()
  updateVideoModalSize()
  adjustContactUsMarginTop()
  setTimeout(window.scrollTo(0, 0), 10)
  setTimeout(shakeWatchVideoAnchor, 500)
